import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useGet2FA = function () {
    var intl = useIntl();
    var _a = useMutation(function () {
        return api.base
            .post('/api/user/get2fa')
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { get2FA: mutateAsync, isLoading: isLoading };
};
